import { useEffect, useState } from "react";
import { ShieldCheck, KeyRound, Save } from "lucide-react";
import { toast } from "sonner";
import { authApi } from "../lib/auth";

// Solo configurazione OAuth per l'identità: NON abilita o collega Gmail.
export default function GoogleLoginSettings() {
  const [config, setConfig] = useState(null);
  const [clientId, setClientId] = useState("");
  const [secret, setSecret] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let active = true;
    authApi.googleLoginConfig()
      .then((data) => {
        if (!active) return;
        setConfig(data);
        setClientId(data.client_id || "");
      })
      .catch(() => { if (active) toast.error("Configurazione login Google non disponibile"); });
    return () => { active = false; };
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      await authApi.saveGoogleLoginConfig({ client_id: clientId.trim(), client_secret: secret.trim() });
      const latest = await authApi.googleLoginConfig();
      setConfig(latest);
      setSecret("");
      toast.success("Login Google configurato. Gmail rimane indipendente.");
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Impossibile salvare l'accesso Google");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="bg-white border border-slate-200 rounded-2xl p-5 space-y-3" data-testid="google-login-settings">
      <div className="flex gap-2 items-center">
        <ShieldCheck className="w-5 h-5 text-orange-600"/>
        <h2 className="font-semibold text-slate-900">Accesso Google degli utenti</h2>
        {config?.configured && <span className="text-xs text-emerald-700 bg-emerald-50 px-2 py-1 rounded">Configurato</span>}
      </div>
      <p className="text-sm text-slate-500">
        Configura il client OAuth per accedere a ELLEBIERRE con Google. Serve solo a verificare
        l'identità degli utenti autorizzati in Impostazioni → Utenti: non legge email, contatti o calendari.
        Il collegamento Gmail è una funzione separata.
      </p>
      {config && <>
        <p className="text-xs text-slate-500">Origine autorizzata: <code>{config.origin}</code></p>
        <p className="text-xs text-slate-500 break-all">URI di reindirizzamento: <code>{config.redirect_uri}</code></p>
      </>}
      <form onSubmit={submit} className="flex flex-col gap-3 max-w-2xl">
        <label className="text-sm font-semibold text-slate-700">
          Client ID (Google OAuth, applicazione web)
          <input value={clientId} onChange={e => setClientId(e.target.value)}
            placeholder="...apps.googleusercontent.com" required autoComplete="off"
            data-testid="google-login-client-id"
            className="mt-1 block w-full border border-slate-300 rounded-lg px-3 py-2 font-mono text-sm" />
        </label>
        <label className="text-sm font-semibold text-slate-700">
          Client Secret {config?.configured ? "(solo per sostituire il client corrente)" : ""}
          <input type="password" value={secret} onChange={e => setSecret(e.target.value)}
            required autoComplete="new-password" data-testid="google-login-client-secret"
            className="mt-1 block w-full border border-slate-300 rounded-lg px-3 py-2 font-mono text-sm" />
        </label>
        <button type="submit" disabled={busy || !clientId.trim() || !secret.trim()}
          data-testid="google-login-config-save"
          className="self-start bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white px-4 py-2 rounded-lg text-sm font-semibold">
          <Save className="inline w-4 h-4 mr-2"/> {busy ? "Salvataggio..." : "Salva configurazione Google"}
        </button>
      </form>
      <div className="text-xs text-slate-500 flex items-center gap-2">
        <KeyRound className="w-4 h-4"/> Il Client Secret non verrà mostrato dopo il salvataggio.
      </div>
    </section>
  );
}
